import { useCallback, useEffect, useState } from 'react';

import { client, useErrorNotifications, useFormErrorHandler } from 'core/http';
import { ProductSchema } from 'core/schemas/product';
import { Product } from 'core/types/product';

export default function useProduct(id: string) {
  const handleFormErrors = useFormErrorHandler();
  const showErrorNotification = useErrorNotifications();
  const [product, setProduct] = useState<Product>();

  useEffect(() => {
    client()
      .get<Product>(`products/${id}`)
      .then(response => response.data)
      .then(setProduct)
      .catch(showErrorNotification);
  }, [showErrorNotification, id]);

  const update = useCallback(
    (payload: ProductSchema) => {
      return client()
        .patch<Product>(`products/${id}`, payload)
        .then(response => response.data)
        .then(setProduct)
        .catch(handleFormErrors);
    },
    [id, handleFormErrors]
  );

  return { product, update };
}
